// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Screen reader only (for announcements) */
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}

/* ===== Trigger Button (shown in settings panel) ===== */
.lang-trigger-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    background: var(--bg-primary);
    border: 2px solid var(--border-secondary);
    border-radius: 12px;
    padding: 8px 16px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: inherit;
    color: var(--text-primary);
    font-size: 14px;
    font-weight: 600;
}

.lang-trigger-btn:hover {
    border-color: var(--border-hover);
    transform: translateY(-1px);
}

.lang-trigger-icon {
    font-size: 16px;
    color: var(--accent-primary);
}

.lang-trigger-name {
    white-space: nowrap;
}

/* ===== Modal Overlay ===== */
.lang-modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 200;
    animation: langFadeIn 0.2s ease-out;
}

.lang-modal {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: var(--bg-secondary);
    border: 2px solid var(--border-secondary);
    border-radius: 20px;
    padding: 24px;
    z-index: 201;
    width: 90%;
    max-width: 420px;
    animation: langSlideIn 0.25s ease-out;
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.3);
}

.lang-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.lang-modal-title {
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
}

.lang-modal-close {
    background: transparent;
    border: none;
    color: var(--text-muted);
    font-size: 20px;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 8px;
    transition: all 0.2s ease;
    line-height: 1;
}

.lang-modal-close:hover {
    color: var(--text-primary);
    background: var(--bg-tertiary);
}

/* ===== Language Grid inside Modal ===== */
.lang-modal-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
}

.lang-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    background: var(--bg-primary);
    border: 2px solid var(--border-secondary);
    border-radius: 14px;
    padding: 14px 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: inherit;
}

.lang-card:hover:not(.active) {
    border-color: var(--border-hover);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.lang-card:active {
    transform: scale(0.96);
}

.lang-card.active {
    border-color: var(--accent-primary);
    background: var(--bg-tertiary);
    cursor: default;
}

.lang-card-name {
    font-size: 15px;
    font-weight: 600;
    color: var(--text-primary);
    white-space: nowrap;
}

.lang-card.active .lang-card-name {
    color: var(--accent-primary);
}

.lang-card-code {
    font-size: 11px;
    color: var(--text-muted);
    font-weight: 500;
    letter-spacing: 0.5px;
}

/* ===== Animations ===== */
@keyframes langFadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

@keyframes langSlideIn {
    from {
        opacity: 0;
        transform: translate(-50%, -48%);
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%);
    }
}

/* ===== Responsive ===== */
@media (max-width: 480px) {
    .lang-modal {
        width: 94%;
        padding: 20px 16px;
        border-radius: 16px;
    }

    .lang-modal-grid {
        gap: 8px;
    }

    .lang-card {
        padding: 12px 6px;
        border-radius: 12px;
    }

    .lang-card-name {
        font-size: 13px;
    }

    .lang-trigger-btn {
        padding: 6px 12px;
        font-size: 13px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/LanguageSwitch.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA,yDAAyD;AACzD;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,6BAA6B;IAC7B,yCAAyC;IACzC,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,oBAAoB;IACpB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA,8BAA8B;AAC9B;IACI,eAAe;IACf,QAAQ;IACR,8BAA8B;IAC9B,YAAY;IACZ,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,+BAA+B;IAC/B,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,qCAAqC;IACrC,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,wBAAwB;IACxB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA,2CAA2C;AAC3C;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,6BAA6B;IAC7B,yCAAyC;IACzC,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mCAAmC;IACnC,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA,2BAA2B;AAC3B;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI;QACI,UAAU;QACV,gCAAgC;IACpC;IACA;QACI,UAAU;QACV,gCAAgC;IACpC;AACJ;;AAEA,2BAA2B;AAC3B;IACI;QACI,UAAU;QACV,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ","sourcesContent":["/* Screen reader only (for announcements) */\n.sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n}\n\n/* ===== Trigger Button (shown in settings panel) ===== */\n.lang-trigger-btn {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: var(--bg-primary);\n    border: 2px solid var(--border-secondary);\n    border-radius: 12px;\n    padding: 8px 16px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-family: inherit;\n    color: var(--text-primary);\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.lang-trigger-btn:hover {\n    border-color: var(--border-hover);\n    transform: translateY(-1px);\n}\n\n.lang-trigger-icon {\n    font-size: 16px;\n    color: var(--accent-primary);\n}\n\n.lang-trigger-name {\n    white-space: nowrap;\n}\n\n/* ===== Modal Overlay ===== */\n.lang-modal-backdrop {\n    position: fixed;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 200;\n    animation: langFadeIn 0.2s ease-out;\n}\n\n.lang-modal {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: var(--bg-secondary);\n    border: 2px solid var(--border-secondary);\n    border-radius: 20px;\n    padding: 24px;\n    z-index: 201;\n    width: 90%;\n    max-width: 420px;\n    animation: langSlideIn 0.25s ease-out;\n    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.3);\n}\n\n.lang-modal-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.lang-modal-title {\n    font-size: 18px;\n    font-weight: 700;\n    color: var(--text-primary);\n}\n\n.lang-modal-close {\n    background: transparent;\n    border: none;\n    color: var(--text-muted);\n    font-size: 20px;\n    cursor: pointer;\n    padding: 4px 8px;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n    line-height: 1;\n}\n\n.lang-modal-close:hover {\n    color: var(--text-primary);\n    background: var(--bg-tertiary);\n}\n\n/* ===== Language Grid inside Modal ===== */\n.lang-modal-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n}\n\n.lang-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    background: var(--bg-primary);\n    border: 2px solid var(--border-secondary);\n    border-radius: 14px;\n    padding: 14px 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-family: inherit;\n}\n\n.lang-card:hover:not(.active) {\n    border-color: var(--border-hover);\n    transform: translateY(-2px);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.lang-card:active {\n    transform: scale(0.96);\n}\n\n.lang-card.active {\n    border-color: var(--accent-primary);\n    background: var(--bg-tertiary);\n    cursor: default;\n}\n\n.lang-card-name {\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--text-primary);\n    white-space: nowrap;\n}\n\n.lang-card.active .lang-card-name {\n    color: var(--accent-primary);\n}\n\n.lang-card-code {\n    font-size: 11px;\n    color: var(--text-muted);\n    font-weight: 500;\n    letter-spacing: 0.5px;\n}\n\n/* ===== Animations ===== */\n@keyframes langFadeIn {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n@keyframes langSlideIn {\n    from {\n        opacity: 0;\n        transform: translate(-50%, -48%);\n    }\n    to {\n        opacity: 1;\n        transform: translate(-50%, -50%);\n    }\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 480px) {\n    .lang-modal {\n        width: 94%;\n        padding: 20px 16px;\n        border-radius: 16px;\n    }\n\n    .lang-modal-grid {\n        gap: 8px;\n    }\n\n    .lang-card {\n        padding: 12px 6px;\n        border-radius: 12px;\n    }\n\n    .lang-card-name {\n        font-size: 13px;\n    }\n\n    .lang-trigger-btn {\n        padding: 6px 12px;\n        font-size: 13px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
